import { useState } from 'react';
import * as Yup from 'yup';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Link, Stack, Alert, IconButton, InputAdornment, Button } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// auth
import { useAuthContext } from '../../../auth/useAuthContext';
// components
import Iconify from '../../../components/iconify';
import FormProvider, { RHFTextField } from '../../../components/hook-form';
import useIsMountedRef from '../../../hooks/useIsMountedRef';
import { PATH_AUTH } from '../../../routes/paths';

// ----------------------------------------------------------------------

export default function AuthLoginForm() {
	const { loginWithEmailPassword, resendEmail } = useAuthContext();
	const isMountedRef = useIsMountedRef();

	const [showPassword, setShowPassword] = useState(false);
	const [showSendEmail, setShowSendEmail] = useState(false);
	const [currentEmail, setCurrentEmail] = useState('');

	const LoginSchema = Yup.object().shape({
		email: Yup.string().email('Email must be a valid email address').required('Email is required'),
		password: Yup.string().required('Password is required'),
	});

	const defaultValues = {
		email: '',
		password: '',
	};

	const methods = useForm({
		resolver: yupResolver(LoginSchema),
		defaultValues,
	});

	const {
		reset,
		setError,
		handleSubmit,
		formState: { errors, isSubmitting, isSubmitSuccessful },
	} = methods;



    const SendEmailButton = ()=>{
        return (
          <>
            {
              showSendEmail && 
              <Button component="button" variant="subtitle2" onClick={(event) => {sendEmail(event)}}>
                        Resend email
              </Button>
            }
          </>
        )
      }
    
    function sendEmail(event){
        event.preventDefault();
        console.log(currentEmail);
        if(currentEmail !== '')
          resendEmail(currentEmail);
      }

	const onSubmit = async (data) => {
		const prom = new Promise((resolve, reject)=> {

			try {
				console.log(data.email);
				console.log(data.password);
				loginWithEmailPassword(data.email, data.password)
				.then((message)=>{
					console.log("success", message);
				}).catch((error) => {
					console.log(error);
					if(error.message !== 'No error'){
						// setIsSubmitting(false)
						if(error.message === 'Email Not Verified')
						    setShowSendEmail(true);
						setCurrentEmail(data.email);
						if (isMountedRef.current) {
							console.log('test');
							setError('afterSubmit', { ...error, message: error.message });
						}
						reject();
					} else if (error.message === "MFA"){
                        console.log("MFA");
                    } else{
						resolve();
					}
				});
			} catch (error) {
				if(error.message !== 'No error'){
					// setIsSubmitting(false)
					if(error.message === 'Email Not Verified')
					setShowSendEmail(true);
					if (isMountedRef.current) {
                        console.log('test');
                        setError('afterSubmit', { ...error, message: error.message });
					}
					reject();
				} else {
					resolve();
				}
			}
		});
		return prom;
	};

	return (
		<FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={3}>
                {
                    !!errors.afterSubmit && 
                    <Alert severity="error">
                        {errors.afterSubmit.message}
                        <SendEmailButton/>
                    </Alert>
                }

                <RHFTextField name="email" label="Email address" />

                <RHFTextField
                name="password"
                label="Password"
                type={showPassword ? 'text' : 'password'}
                InputProps={{
                    endAdornment: (
                    <InputAdornment position="end">
                        <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                        <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                        </IconButton>
                    </InputAdornment>
                    ),
                }}
                />
            </Stack>

            <Stack alignItems="flex-end" sx={{ my: 2 }}>
                <Link variant="body2" color="inherit" underline="always" href={PATH_AUTH.resetPassword}>
                Forgot password?
                </Link>
            </Stack>

            <LoadingButton
                fullWidth
                color="inherit"
                size="large"
                type="submit"
                variant="contained"
                loading={isSubmitSuccessful || isSubmitting}
                sx={{
                bgcolor: 'text.primary',
                color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
                '&:hover': {
                    bgcolor: 'text.primary',
                    color: (theme) => (theme.palette.mode === 'light' ? 'common.white' : 'grey.800'),
                },
                }}
            >
                Login
            </LoadingButton>
		</FormProvider>
	);
}
